export const SERVICE_STEPS = {
  STRUCTURING: 1,
  SETUP: 2,
  DISTRIBUTION: 3,
  OPERATION: 4,
};
